import React, { useCallback } from 'react';
import { useController } from 'react-hook-form';
import RadioButton from '../radio-button-group/containers/radio-button';
import RadioButtonGroup from '../radio-button-group';
import FieldStatus from '../field-status';
import noop from '../../../utils/noop';

const defaultRules = {};

const RadioButtonGroupField = ({
  name,
  control,
  options,
  rules = defaultRules,
  onChange = noop,
}) => {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  const handleChange = useCallback(
    (value, event) => {
      field.onChange(value);
      onChange(value, event);
    },
    [field, onChange]
  );

  return (
    <RadioButtonGroup name={name} selectedValue={field.value} onChange={handleChange}>
      {options.map(({ value, label, isLabelBold }, index) => {
        const id = `${field.name}-${index}`;

        return (
          <RadioButton
            {...(index === 0 && { inputRef: field.ref })}
            key={id}
            id={id}
            value={value}
            label={label}
            isLabelBold={isLabelBold}
          />
        );
      })}
      {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
    </RadioButtonGroup>
  );
};

export default RadioButtonGroupField;
